"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.connectAlgorandWalletAddress = exports.disconnectAlgorandWallet = exports.catchAlgorandWalletConnectError = exports.algorandWalletConnected = exports.algorandConnectWallet = exports.reconnectAlgorandWallet = void 0;
const algorandWalletConnectorSlice_1 = require("./algorandWalletConnectorSlice");
const { actions } = algorandWalletConnectorSlice_1.algorandWalletConnectorSlice;
const reconnectAlgorandWallet = () => (dispatch) => {
    dispatch(actions.reconnectAlgorandWallet());
};
exports.reconnectAlgorandWallet = reconnectAlgorandWallet;
const algorandConnectWallet = () => (dispatch) => {
    dispatch(actions.algorandConnectWallet());
};
exports.algorandConnectWallet = algorandConnectWallet;
const algorandWalletConnected = (payload) => (dispatch) => {
    dispatch(actions.algorandWalletConnected(Object.assign({}, payload)));
};
exports.algorandWalletConnected = algorandWalletConnected;
const catchAlgorandWalletConnectError = () => (dispatch) => {
    dispatch(actions.catchAlgorandWalletConnectError({ payload: {} }));
};
exports.catchAlgorandWalletConnectError = catchAlgorandWalletConnectError;
const disconnectAlgorandWallet = () => (dispatch) => {
    dispatch(actions.disconnectAlgorandWallet({ payload: {} }));
};
exports.disconnectAlgorandWallet = disconnectAlgorandWallet;
const connectAlgorandWalletAddress = (address) => (dispatch) => {
    dispatch(actions.connectAlgorandWalletAddress({ address }));
};
exports.connectAlgorandWalletAddress = connectAlgorandWalletAddress;
//# sourceMappingURL=algorandWalletConnectorActions.js.map